module.exports = __webpack_public_path__ + "img/01-T.a279ca64.png";